import { getContext } from '@/context';

const getCurrentUserId = (): string => {
  try {
    return String(getContext().general.auth.getState().id ?? '');
  } catch {
    return '';
  }
};

export default getCurrentUserId;
